import React, { useMemo, useState } from "react";
import { NavLink } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { loaderDecrement, loaderIncrement } from "../services/globalLoader";
import { AVAILABLE_MODULES } from "../components/Access";

const RoleAdd = () => {
  const API_BASE_URL = process.env.REACT_APP_API_URL;

  const userId = useMemo(() => localStorage.getItem("userid"), []);

  const [name, setName] = useState("");
  const [selected, setSelected] = useState([]);
  const [submitting, setSubmitting] = useState(false);

  const toggleModule = (moduleName) => {
    setSelected((prev) =>
      prev.includes(moduleName) ? prev.filter((m) => m !== moduleName) : [...prev, moduleName]
    );
  };

  const reset = () => {
    setName("");
    setSelected([]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!API_BASE_URL) {
      toast.error("Missing REACT_APP_API_URL in environment");
      return;
    }
    if (!userId) {
      toast.error("Missing userId. Please login again.");
      return;
    }
    if (!name.trim()) {
      toast.error("Role name is required");
      return;
    }
    if (!selected.length) {
      toast.error("Select at least one module access");
      return;
    }

    setSubmitting(true);
    let didIncrement = false;
    try {
      const payload = {
        action: "superadmin.createRole",
        userId,
        name: name.trim(),
        access: selected,
      };

      loaderIncrement();
      didIncrement = true;
      const response = await axios.post(`${API_BASE_URL}`, payload);
      const data = response?.data;

      if (data?.status === "success") {
        toast.success(data?.message || "Role created successfully");
        reset();
      } else {
        toast.error(data?.message || "Failed to create role");
      }
    } catch (error) {
      const msg = error?.response?.data?.message || error?.message || "Something went wrong";
      toast.error(msg);
    } finally {
      if (didIncrement) loaderDecrement();
      setSubmitting(false);
    }
  };

  return (
    <div className="employee-form">
      <div className="content-header">
        <div className="container-fluid d-flex justify-content-between align-items-end flex-wrap" style={{ gap: 12 }}>
          <div>
            <h1 className="m-0 txt_lft">Add Role</h1>
            <p style={{ margin: 0 }}>Create roles and assign module access.</p>
          </div>
          <NavLink to="/role" className="btn btn-secondary">
            Back
          </NavLink>
        </div>
      </div>

      <div className="content">
        <div className="container-fluid">
          <div className="card">
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-4">
                    <div className="form-group">
                      <label className="form-label">
                        Role Name <span className="required-star">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Role"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                </div>

                <div className="mt-2">
                  <label className="form-label">
                    Access <span className="required-star">*</span>
                  </label>
                  <div className="row">
                    {AVAILABLE_MODULES.map((m) => (
                      <div className="col-12 col-md-4 col-lg-3" key={m} style={{ marginBottom: 10 }}>
                        <div className="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id={`access-${m}`}
                            checked={selected.includes(m)}
                            onChange={() => toggleModule(m)}
                          />
                          <label className="custom-control-label" htmlFor={`access-${m}`}>
                            {m}
                          </label>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="d-flex" style={{ gap: 12, justifyContent: "flex-end", marginTop: 12 }}>
                  <button type="submit" className="btn btn-primary" disabled={submitting}>
                    {submitting ? "Creating..." : "Create Role"}
                  </button>
                  <button type="button" className="btn btn-secondary" onClick={reset} disabled={submitting}>
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoleAdd;